import { render, staticRenderFns } from "./FormattingDate.vue?vue&type=template&id=2ce44780&"
import script from "./FormattingDate.vue?vue&type=script&lang=js&"
export * from "./FormattingDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports